import React from 'react';

interface Props {
	title: string;
	content: string;
}

const AdditionalInfoContentBlock = ({ title, content }: Props) => {
	return (
		<div>
			<div className="text-base font-medium text-[#28293D] dark:text-[#F2F2F5]">{title}</div>
			<div className="text-sm text-[#111928] dark:text-[#C7C9D9] mt-1">{content}</div>
		</div>
	);
};

export default AdditionalInfoContentBlock;
